const footerData = {
  homepage: "/",
  categories: [
    {
      title: "Company",
      links: [
        {
          text: "Trust center",
          href: "/trust-center/"
        },
        {
          text: "Events",
          href: "/events/"
        },
        {
          text: "About us",
          href: "/about-us/",
        },
        {
          text: "Jobs",
          href: "/jobs/"
        },
        {
          text: "Sustainability",
          href: "/greener-hosting/",
        },
        {
          text: "FAQ",
          href: "/faq/",
        },
        {
          text: "Open source",
          href: "/community/open-source/",
        }
      ],
    },
    {
      title: "Product",
      links: [
        {
          text: "Overview",
          href: "/product/",
        },
        {
          text: "Features",
          href: "/features/",
        },
        {
          text: "Pricing",
          href: "/pricing/",
        },
        {
          text: "Pricing calculator",
          href: "/pricing/calculator/"
        }
      ],
    },
    {
      title: "Industries",
      links: [
        {
          text: "Retail",
          href: "/industry/retail/"
        },
        {
          text: "Higher education",
          href: "/industry/higher-education/"
        },
        {
          text: "SaaS",
          href: "/industry/saas/"
        },
        {
          text: "Travel and hospitality",
          href: "/industry/travel-and-hospitality/"
        },
        {
          text: "Financial Services",
          href: "/industry/financial-services/"
        },
        {
          text: "Government",
          href: "/industry/government/"
        },
      ]
    },
    {
      title: "Resources",
      links: [
        {
          text: "Case studies",
          href: "/blog/case-studies/"
        },
        {
          text: "Blog",
          href: "/blog/",
        },
        {
          text: "Developer Center",
          href: "https://devcenter.upsun.com/",
        },
        {
          text: "Documentation",
          href: "https://docs.upsun.com/",
        },
        {
          text: "Cloud regions",
          href: "/regions/",
        },
        {
          text: "Support",
          href: "https://console.upsun.com/-/users/:user/tickets/open",
        },
        {
          text: "Contact us",
          href: "/contact-us/",
        },
      ],
    },
    {
      title: "Use cases",
      links: [
        {
          text: "SaaS hosting",
          href: "/solutions/saas/"
        },
        {
          text: "Application modernization",
          href: "/solutions/application-modernization/"
        },
        {
          text: "eCommerce hosting",
          href: "/solutions/ecommerce/"
        },
        {
          text: "CMS hosting",
          href: "/solutions/cms/"
        },
        {
          text: "Multi site management",
          href: "/solutions/multi-site-management/"
        },
        {
          text: "SaaS extensions",
          href: "/solutions/saas-extensions/"
        },
        {
          text: "Backend solutions",
          href: "/solutions/backend/"
        },
      ]
    },
    {
      title: "Compare",
      links: [
        {
          text: "Vercel alternative",
          href: "/vercel-alternative/"
        },
        {
          text: "Amazee alternative",
          href: "/amazee-alternative/"
        },
        {
          text: "Heroku alternative",
          href: "/heroku-alternative/"
        },
        {
          text: "Pantheon alternative",
          href: "/pantheon-alternative/"
        },
        {
          text: "Managed hosting alternative",
          href: "/managed-hosting-alternative/"
        },
        {
          text: "Fly.io alternative",
          href: "/fly-io-alternative/"
        },
        {
          text: "Render alternative",
          href: "/render-alternative/"
        },
        {
          text: "AWS alternative",
          href: "/aws-alternative/"
        },
        {
          text: "Acquia alternative",
          href: "/acquia-alternative/"
        },
        {
          text: "DigitalOcean alternative",
          href: "/digitalocean-alternative/"
        }
      ]
    }
  ],
  bottomLinks: [
    {
      href: "/trust-center/legal/tos/",
      text: "Terms of Service",
    },
    {
      href: "/trust-center/privacy/privacy-notice/",
      text: "Privacy",
    },
    {
      href: "/trust-center/legal/impressum/",
      text: "Impressum",
    },
    {
      href:
        "/trust-center/security/responsible-disclosure/",
      text: "Report a security issue",
    },
  ],
};


export default footerData;